export default __webpack_public_path__ + "static/media/zebec.781f2fbb.png";